module.exports = __webpack_public_path__ + "img/easy-fat-free-cheesecake.abd3cfea.jpg";